package com.arena_web.data.api

import com.arena_web.data.dto.*
import com.arena_web.data.http.ApiResponse
import com.arena_web.data.http.apiGet
import io.ktor.client.*

class ClubPublicApi(private val client: HttpClient) {

    suspend fun browseClubs(params: Map<String, String> = emptyMap()): ApiResponse<ClubListPageDto> {
        return client.apiGet("v1/public/clubs", params)
    }

    suspend fun getClubDetail(clubId: String): ApiResponse<PublicClubDetailDto> {
        return client.apiGet("v1/public/clubs/$clubId")
    }

    suspend fun getSchedule(clubId: String): ApiResponse<ClubScheduleDto> {
        return client.apiGet("v1/public/clubs/$clubId/schedule")
    }

    suspend fun getFeed(clubId: String, params: Map<String, String> = emptyMap()): ApiResponse<ClubPostPageDto> {
        return client.apiGet("v1/public/clubs/$clubId/feed", params)
    }

    suspend fun getReviews(clubId: String, params: Map<String, String> = emptyMap()): ApiResponse<ClubReviewPageDto> {
        return client.apiGet("v1/public/clubs/$clubId/reviews", params)
    }

    suspend fun getFieldPricing(clubId: String, fieldId: String): ApiResponse<List<FieldPricingDto>> {
        return client.apiGet("v1/public/clubs/$clubId/fields/$fieldId/pricing")
    }

    suspend fun getFieldAvailability(
        clubId: String,
        fieldId: String,
        params: Map<String, String>
    ): ApiResponse<FieldAvailabilityDto> {
        return client.apiGet("v1/public/clubs/$clubId/fields/$fieldId/availability", params)
    }
}
